import { render, staticRenderFns } from "./BancoDeCartasTRVisualizar.vue?vue&type=template&id=86710b6c"
import script from "./BancoDeCartasTRVisualizar.vue?vue&type=script&lang=js"
export * from "./BancoDeCartasTRVisualizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports